import getPixelsForCfi from '../getPixelsForCfi';
import getCfiForPixelOffset from '../getCfiForPixelOffset';
import BookLocation from 'types/BookLocation';

/**
 * @method getNextLocationFromCfi
 * @param {Element} frame
 * @param {Object} document
 * @param {String} cfi
 */
const getNextLocationFromCfi = (frame, document, cfi) => {
  if (!cfi) {
    throw new Error('cfi is required');
  }

  const frameParent = frame.parentElement.parentElement;
  const maxScrollTop = frameParent.scrollHeight - frameParent.offsetHeight; // max pixels to scroll

  const pixelAtCfi = getPixelsForCfi(frame, cfi);

  let scrollPixelIncrement = 0;
  let incrementBy = 100;

  function findNewBookLocation(frame, pixelAtCfi, scrollPixelIncrement) {
    const scrollTop = pixelAtCfi + scrollPixelIncrement;
    const nextScrollTop = Math.min(
      Math.round(scrollTop + frameParent.offsetHeight / 2),
      maxScrollTop,
    );

    if (nextScrollTop >= maxScrollTop) {
      return document.next?.bookLocation;
    }

    const nextCfi = getCfiForPixelOffset(frame, nextScrollTop);
    const nextBookLocation = new BookLocation({
      document,
      cfi: nextCfi,
    });

    nextBookLocation.resolve(frame);

    return nextBookLocation;
  }

  let newBookLocation = findNewBookLocation(
    frame,
    pixelAtCfi,
    scrollPixelIncrement,
  );

  while (incrementBy > 1) {
    if (newBookLocation?.cfi === cfi) {
      scrollPixelIncrement = incrementBy + scrollPixelIncrement;
    } else {
      incrementBy = incrementBy / 10;
      scrollPixelIncrement = incrementBy + scrollPixelIncrement;
    }
    newBookLocation = findNewBookLocation(
      frame,
      pixelAtCfi,
      scrollPixelIncrement,
    );
  }

  return newBookLocation;
};

export default getNextLocationFromCfi;
